module.exports = __webpack_public_path__ + "img/icon_white_fork-knife.c631603d.svg";